import { axiosInstance } from "utils/axiosInstance";
import { partnerURL } from "utils/urls";

export const getPartnerServ = async (id) => {
  return await axiosInstance
    .get(`${partnerURL}/${id}`)
    .then((res) => res.data)
    .catch((err) => new Error(err.response ? err.response.data.message : "Getting Partner failed"));
}